<template>
  <main class="share-retailer">
    <transition name="fade">
      <popup v-if="isShown" :mode="popupMode">
        <popup-thanks slot="content" />
      </popup>
    </transition>

    <viewport-height>
      <div class="share-retailer__wrapper">
        <result-model
          :title="options.shareRetailer.title"
          :text="options.shareRetailer.text"
        >
          <div slot="otherContent" class="result-model__form">
            <result-form @success="showModalThanks" />
          </div>
        </result-model>
      </div>
    </viewport-height>
  </main>
</template>

<script>
import { mixin } from '../mixin';
import Popup from './components/popup.vue';
import popupThanks from './components/popupThanks.vue';
import viewportHeight from './components/viewportHeight.vue';
import resultModel from './components/resultModel.vue';
import resultForm from './components/resultForm.vue';

export default {
  name: 'shareRetailerElement',
  mixins: [mixin],
  components: {
    Popup,
    popupThanks,
    viewportHeight,
    resultModel,
    resultForm,
  },
  data() {
    return {
      isShown: false,
      popupMode: 'thanks',
    };
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
  },
  mounted() {},
  methods: {
    showModalThanks() {
      this.isShown = true;
      this.scrollHide();
    },
  },
};
</script>

<style scoped lang="scss"></style>
